// extracted by mini-css-extract-plugin
module.exports = {"oauth2":"oauth2-authorize_oauth2_3lIvY","btnWrap":"oauth2-authorize_btnWrap_3AIzn"};